import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { HttpClient,HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { MatDialog } from '@angular/material/dialog';
import { SuccessDialogComponent } from '../success-dialog/success-dialog.component';
import { TestConsentDialogComponent } from 'src/app/Core/components/test-consent-dialog/test-consent-dialog.component';
import { ToasterService } from 'src/app/Core/services/toaster.service';
import { ConfirmationDialogComponent } from 'src/app/Core/components/confirmation-dialog/confirmation-dialog.component';

interface UserConsentRecord {
  id: number;
  created: string;
  agentId: number;
  data: UserConsentData; // Use the defined interface here
  communicationType: string;
  expiry: string | null;
  isactive: boolean;
  notified: boolean;
  priority: number;
  repeatable: boolean;
  agentName: string | null;
}

interface UserConsentData {
  footer: string;
  header: string;
  content: string;
  contenttype: string;
  useractions: {
    url: string;
    name: string;
    type: string;
    value: string;
    ackrequired: boolean;
    cancontinue: boolean;
  }[];
  displayname?: string; // Add this property with optional '?'
  allowUsingApp?: string; // Add this property with optional '?'
}

@Component({
  selector: 'app-alert-ctl',
  templateUrl: './alert-ctl.component.html',
  styleUrls: ['./alert-ctl.component.css']
})
export class AlertCtlComponent implements OnInit {
  currentPage: number = 1;
  pageSize: number = 5;
  totalPages: number = 0;

  defaultPlaceholder: string = '5 items per page';

  userConsentForm: FormGroup;
  records: UserConsentRecord[] = [];
  consents: any[]=[]; // Replace 'any[]' with the correct type of 'consents' array.
  action: any=''; // Replace 'any' with the correct type of 'action'.
  displayName: string = ''; // Initialize with default value
  userType: string = 'action'; // Initialize with default value
  userValue: string = 'accept'; // Initialize with default value
  allowApp: string = 'yes'; // Initialize with default value
  addedActions: any[]=[];
  // Add this property to your component
  consentSearchInputs: string[] = [];
  showTable = false;
  

  selectedCommunicationType: string = "api";
  enteredHeader: string = '';
  selectedConsentType : string = 'static';
  HTMLContent: string='';
  FooterText: string='';
  showContent: boolean = false;
  consentReleased: boolean = false;
  TestEMail: string = '';
  isModalOpen:boolean =false;
  currentStep: string = 'createConsent';
  headerPlaceholder: string = 'Enter header here';
  contentPlaceholder: string = 'Enter content here';
  displayPlaceholder: string='OK/Accept'
  footerPlaceholder: string='Enter Footer here'
  headerInteracted: boolean = false;
  contentInteracted: boolean = false;
  displayInteracted:boolean=false;
  footerInteracted: boolean=false;
  dynamicContentError: string = '';

  addAction() {
    if (this.displayName.trim() === '') {
      console.error('Display Name is required');
      this.displayPlaceholder="Display Name is required";
      return;
    }
  
    const newAction = {
      userType: this.userType,
      userValue: this.userValue,
      displayName: this.displayName,
      allowApp: this.allowApp
    };

    this.addedActions.push(newAction);
    this.showTable = true;

    // Reset input fields
    this.userType = 'action';
    this.userValue = 'accept';
    this.displayName = '';
    this.allowApp = 'yes';
  } 

  onAllowAppChange(event: any) {
    // Handle the change event here
    // For example, update the 'allowApp' property
    this.allowApp = event;
  }
  

  constructor(private fb: FormBuilder,private http: HttpClient,private dialog: MatDialog, private toaster: ToasterService) {
    this.action = {
      allowApp: 'yes',
    };

    this.userConsentForm = this.fb.group({
      communicationType: ['', Validators.required],
      header: ['', Validators.required],
      content: ['',Validators.required],
      footer : ['', Validators.required]

      // Add more form controls as needed
    });
  }
  
  openSuccessDialog(message: string) {
    this.dialog.open(SuccessDialogComponent, {
      data: { message },
    });
  }

  openDeleteDialog(message:string){
    this.dialog.open(SuccessDialogComponent,{
      data: {message},
    });
  }
  
  openTestDialog(consent: UserConsentRecord): void {
    const dialogRef = this.dialog.open(TestConsentDialogComponent, {
      width: '700px',
      data: { consent: consent, testConsent: this.testConsent.bind(this) } 
    });

    dialogRef.afterClosed().subscribe(result => {
    });
  }

  ngOnInit() {
    // Fetch data from the API and populate the records array
    this.fetchUserConsentData();
  }

  moveToNextStep(step: string) {
    if (step === 'userType' && (this.enteredHeader.trim() === '' && !this.headerInteracted)) {
        this.headerPlaceholder = 'Header is required'; 
        return;
    }
    if (step === 'userType' && (this.HTMLContent.trim() === '' && !this.contentInteracted)) {
        this.contentPlaceholder = 'Content is required';
        return;
    } 
    if (step === 'userType' && this.selectedConsentType === 'dynamic' && !this.HTMLContent.endsWith('.html')) {
        this.dynamicContentError = 'Dynamic content requires HTML file';
        return;
    } else {
        this.dynamicContentError = ''; 
    }
    if (step === 'footer' && (this.addedActions.length < 1)) {
        this.displayPlaceholder="Display Name is required";
        return;
    }

    this.currentStep = step;
}


  moveToPrevStep(step: string) {
    this.currentStep = step;
  }

  resetCreateConsent() {
    this.selectedCommunicationType = "api";
    this.enteredHeader = '';
    this.selectedConsentType = "static";
    this.HTMLContent = '';
  }
  
  resetUserType() {
    this.userType = 'action';
    this.userValue = '';
    this.displayName = '';
    this.action.allowApp = 'yes';
    this.addedActions = [];
  }
  
  resetFooter() {
    this.FooterText = '';
  }
  // Add your form submit logic here

  onAddAction() {
    
     // Push the current action data into the addedActions array
     this.addedActions.push({
      displayName: this.displayName,
      userType: this.userType,
      userValue: this.userValue,
      allowApp: this.allowApp
    });

    // Reset form and fields
    this.userConsentForm.reset();
    this.userType = 'action';
    this.userValue = 'accept';
    this.allowApp = 'no';
  }

  removeAction(index: number) {
    this.addedActions.splice(index, 1);
  }

  onSubmit(form: any) {
    if (form.valid) {

      // Update the displayed data
       this.displayName = this.userConsentForm.get('displayname')?.value || '';
      this.userType = this.userType;
      this.userValue = this.userValue;
      this.allowApp = this.action.allowApp;

      // Optionally, you can push this data into an array to display multiple rows in the table.
      // Example:
      // this.records.push({
      //   displayName: this.displayName,
      //   userType: this.userType,
      //   userValue: this.userValue,
      //   allowApp: this.allowApp
      // });

      // Reset form and fields
      this.userConsentForm.reset();
      this.userType = 'action';
      this.userValue = 'accept';
      this.allowApp = 'yes';
    } else {
      // Handle the case when the form is not valid (required fields are empty).
      console.error("Form is not valid. Please fill all required fields.");
    }
  }

  selectedConsent: UserConsentRecord | null = null;
  pendingPayload: any = null; // Store the payload to be released
  private sharedPendingPayload: any = null;

  postDataToServer() {
    if (this.FooterText.trim() === '') {
      this.footerInteracted = true;
      this.footerPlaceholder = 'Footer is required';
      return;
    }

    const userActions = this.addedActions.map((action) => {
      return {
        displayName: action.displayName,
        allowUsingApp: action.allowApp === 'yes',
        type: action.userType,
        value: action.userValue,
        navigationURL: '',
      };
    });  
    
    const payload = {
      communicationType: this.selectedCommunicationType,
      header: this.enteredHeader,
      contentType: this.selectedConsentType,
      content: this.HTMLContent,
      userActions: userActions,
      footer: this.FooterText,
      notified: this.consentReleased
    };
  
    this.pendingPayload = payload;
    this.sharedPendingPayload=payload;
  
    // Perform the POST request
    this.http.post(`${environment.host}/alert`, this.pendingPayload).subscribe(
      (response) => {
        // Handle successful response
        const message = 'The Consent was created Successfully !!';
        this.openSuccessDialog(message);
        this.isModalOpen = true;
  
        this.resetForm();
        this.currentStep = 'createConsent';
        this.fetchUserConsentData();
      },
      (error) => {
        console.error('Error:', error);
        // Handle error
      }
    );
    if(payload!=null){
     // alert("The Consent was created Successfully !!");
    }
    this.isReleaseSuccessful=true;

    this.selectedConsent = null;
  }
  

  resetForm() {
    this.selectedCommunicationType = "api";
    this.enteredHeader = '';
    this.selectedConsentType = "static";
    this.HTMLContent = '';
    this.FooterText = '';
    this.addedActions = [];
  }
  
  isReleaseSuccessful: boolean = false;
  isDeleteSuccessful: boolean[]= [];
  shouldRender: boolean =false;

  toggleRender(){
    this.shouldRender=!this.shouldRender;
  }
  // selectedConsent: UserConsentRecord | null = null; // Initialize with null

  // Function to confirm release
  confirmRelease(consent: UserConsentRecord) {
    this.selectedConsent = consent; // Store the selected consent
  }

  // Function to cancel release
  cancelRelease() {
    this.selectedConsent = null; 
    this.showContent=false;
    this.isReleaseSuccessful=false;
   
    // Clear the selected consent
  }

  // Function to release the consent
  releaseConsent(consentID: any, Commtype: any, header: any, contentType: any, content: any, action: any, footer: any, timestamp: any, isReleased: boolean) {
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      data: { confirmationText: 'Are you sure you want to release this User Consent?' }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result === 'yes') {
        const payload = {
          communicationType: Commtype,
          header: header,
          contentType: contentType,
          content: content,
          userActions: action,
          footer: footer,
          notified: true
        }

        this.http.post(`${environment.host}/releaseconsent/${consentID}`, payload).subscribe(
          (response) => {
            // Handle successful response
            this.isReleaseSuccessful = true; // Set success state
            alert('consent sent successfully !!')
            this.fetchUserConsentData();
          },
          (error) => {
            console.error('Error:', error);
            this.toaster.openDialogBox("You don't have the required permission", false)
          }
        );
      }
    });
  }

    
  

  testConsent(ID : number,EMail: string){
    
    if(true){
      const payload={
      id: ID,
      username: EMail
      };

      this.http.post(`${environment.host}/testconsent`,payload).subscribe(
      (response) =>{
        
        this.openSuccessDialog(`response from server: ${response} , test consent sent successfully to the - ${EMail} with userID - ${ID}`);
      },
      (error) =>{
        console.error("Error:",error)
           }
        );
    
      
    }
  }
  

  fetchUserConsentData() {
    const apiUrl = `${environment.host}/consent`;
    

    this.http.get<UserConsentRecord[]>(apiUrl).subscribe(
      (data: UserConsentRecord[]) => {
        this.records = data;
        this.consents = data; // Update the consents array with the fetched data
        
        this.totalPages = Math.ceil(this.consents.length / this.pageSize);
      },
      (error) => {
        console.error('Error fetching user consent data:', error);
      }
    );
  }

  prevPage() {
    if (this.currentPage > 1) {
      this.currentPage--;
    }
  }
  
  nextPage() {
    if (this.currentPage < this.totalPages) {
      this.currentPage++;
    }
  }
  
  getDisplayedConsents() {
    const pageSizeNumber = Number(this.pageSize);
    const startIndex = (this.currentPage - 1) * pageSizeNumber;
    const endIndex =Math.min(startIndex + pageSizeNumber, this.consents.length);
    return this.consents.slice(startIndex, endIndex);
  }

  onPageSizeChange(event: any) {
    this.pageSize = event.value;
    this.totalPages = Math.ceil(this.consents.length / this.pageSize);
    this.currentPage = 1; 
  }
  
  openDeleteSuccessDialog() {

    const message = "Record Deleted Successfully !!";
    this.openDeleteDialog(message);
    
  }
  

  deleteConsentData(consentID: number, index: number) {
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      data: { confirmationText: 'Are you sure you want to delete this User Consent?' }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result === 'yes') {
        const apiUrl = `${environment.host}/consent/${consentID}`;
        this.http.delete(apiUrl).subscribe(
          () => {
            this.isDeleteSuccessful[index] = true;
            this.fetchUserConsentData();
            this.openDeleteSuccessDialog();
          },
          (error) => {
            console.error('Error deleting consent', error)
          }
        );
      }
    });
  }
}
